import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  CircularProgress
} from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { subscribe as subscribeConnectivity } from '../services/connectivityService';

const OfflineLockoutScreen: React.FC = () => {
  const [retrying, setRetrying] = useState(false);

  const handleRetry = useCallback(() => {
    setRetrying(true);
    window.location.reload();
  }, []);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    const unsubscribe = subscribeConnectivity(online => {
      if (online) {
        timeout = setTimeout(() => {
          setRetrying(true);
          window.location.reload();
        }, 2000);
      }
    });

    return () => {
      unsubscribe();
      clearTimeout(timeout);
    };
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: 'background.default'
      }}
    >
      <Card sx={{ maxWidth: 400, textAlign: 'center' }}>
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            p: 4
          }}
        >
          <WifiOffIcon sx={{ fontSize: 64, color: 'text.secondary' }} />
          <Typography variant="h5">No Session Found</Typography>
          <Typography variant="body1" color="text.secondary">
            You need to sign in while online before you can use offline mode.
            Please connect to the internet and sign in first.
          </Typography>
          {retrying ? (
            <CircularProgress size={36} />
          ) : (
            <Button variant="contained" onClick={handleRetry}>
              Retry Connection
            </Button>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default OfflineLockoutScreen;
